import React from 'react';

function Privacy() {
  return (
    <>
      <h2>privacy</h2>
    </>
  );
}

export default Privacy;